import { useEffect, useState, useRef } from "react";
import { useUser } from '../services/authService';
import { useNavigate } from "react-router-dom";
import { getCookie } from "../utils/cookieUtil";
import { PiQuestionLight, PiBellLight, PiUserCircleLight } from "react-icons/pi";
import header from '../assets/header.png';
function Header() {
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setrole] = useState('');
  const [userInitials, setUserInitials] = useState('');
  const navigate = useNavigate();
  const { logoutUser } = useUser();
  const dropdownRef = useRef(null);
  useEffect(() => {
    const user = getCookie('user');
    console.log(process.env.REACT_APP_ENV);

    if (user) {

      const firstInitial = user.firstName?.charAt(0).toUpperCase() || '';
      const lastInitial = user.lastName?.charAt(0).toUpperCase() || '';
      setEmail(user.email)
      setrole(user.role)
      setUserInitials(firstInitial + lastInitial);

      setUserName(`${user.firstName} ${user.lastName}`);
    }


  }, []);


  useEffect(() => {
    const user = getCookie('user');
    console.log(user);

    if (user) {
      const firstName = user.firstName
        ? user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1).toLowerCase()
        : '';

      const lastName = user.lastName
        ? user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).toLowerCase()
        : '';

      const firstInitial = firstName.charAt(0);
      const lastInitial = lastName.charAt(0);

      setEmail(user.email);
      setrole(user.role);
      setUserInitials(firstInitial + lastInitial);
      setUserName(`${firstName} ${lastName}`);
    }
  }, []);




  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleLogout = async () => {
    try {
      await logoutUser();
      navigate('/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const toggleProfileMenu = () => setShowProfileMenu(!showProfileMenu);

  // Sample user data (replace with actual logged-in user data)
  const user = {
    name: userName,
    email: email,
    avatar: userInitials,
    role: role
    // or use default profile icon
  };


  return (
    <div ref={dropdownRef} className="flex items-center justify-between bg-white px-6 py-3 shadow h-16  ">
      {/* Left side - Logo */}
      <div className="flex items-center gap-5">
        <img
          src={header}
          alt="header"
          // className="h-8 sm:h-8 md:h-12 w-auto max-w-full mr-4"
          className="w-32 lg:w-80"
        />
      </div>

      {/* Right side - Icons */}
      <div className="flex items-center gap-6">
        <h1 className="text-xs font-semibold text-gray-800 ">
          {process.env.REACT_APP_ENV}
        </h1>

        <PiQuestionLight
          size={26}
          className="cursor-pointer text-gray-500 hover:text-gray-700"
          title="Help"
        />
        <PiBellLight
          size={26}
          className="cursor-pointer text-gray-500 hover:text-gray-700"
          title="Notifications"
        />
        <PiUserCircleLight
          size={26}
          className="cursor-pointer text-black-700"
          title="Profile"
          onClick={toggleProfileMenu}
        />

        {showProfileMenu && (
          <div className="absolute right-0 mt-14 w-64 rounded-md shadow-xl bg-white ring-1 ring-black ring-opacity-5 z-50 overflow-hidden animate-fade-in animate-slide-down">
            <div className="px-4 py-5 text-sm text-gray-700">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full bg-gray-300 text-black flex items-center justify-center font-semibold text-sm animate-pulse">
                  {userInitials}
                </div>
                <div>
                  <div className="font-semibold">{user.name}</div>
                  <div className="text-xs text-gray-500">{user.email}</div>
                  <div className="text-xs text-gray-500">{user.role}</div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-200">
              <button
                onClick={handleLogout}
                className="w-full px-4 py-2 text-sm text-left bg-[#900028] text-white  transition-colors duration-200 ease-in-out"
              >
                Logout
              </button>
            </div>
          </div>

        )}
      </div>
    </div>
  );
}

export default Header;
